import { createResource, type Accessor } from 'solid-js'
import { parse } from 'valibot'
import { backendAxios } from '../../axios'
import { armyPaintDisk } from '../../lib/core/disk/IndexedDBDisk'
import { StateMapDisk } from '../../lib/core/state/state_map_disk.enum'
import { ArmyPaintSchema, type ArmyPaint } from '../../lib/core/ArmyPainter/ArmyPaint.type'
import { isOfflineOnly } from '../../lib/core/isOfflineOnly'
import { hasIndexedDB } from '../../lib/core/Storage/IndexedDB/hasIndexedDB'

export interface ArmyPaintQuery {
  disk?: StateMapDisk
  user_id?: number | null
}

async function fetchArmyPaintCollectionByQuery(inputParams: ArmyPaintQuery): Promise<ArmyPaint[]> {
  const disk = inputParams.disk || StateMapDisk.Cloud
  let collection: ArmyPaint[] = []

  if (disk === StateMapDisk.IndexedDB) {
    if (!hasIndexedDB()) {
      throw new Error('IndexedDB requested but not available')
    }
    collection = await armyPaintDisk.list()
  } else if (disk === StateMapDisk.Cloud && !isOfflineOnly && import.meta.env.VITE_HONO_URL) {
    try {
      const response = await backendAxios.get('/st1/army-paint', { params: inputParams })
      collection = response.data as ArmyPaint[]
    } catch (e) {
      console.error('Failed to fetch army paints from cloud', e)
    }
  } else {
    throw new Error('Invalid disk: ' + disk)
  }

  return collection.map((row) => parse(ArmyPaintSchema, row))
}

export default function createArmyPaintCollectionResource(
  getInputQuery: Accessor<ArmyPaintQuery>
) {
  const resource = createResource(getInputQuery, fetchArmyPaintCollectionByQuery)
  return resource
}
